import { Row, Col, Card, Tag, Button } from "antd";
import { useNavigate } from "react-router-dom";

const CategoryAdminCard = ({ category }) => {
  const statusColors = {
    Available: "green",
    Disabled: "orange",
  };

  const navigate = useNavigate();

  const handleReOrderProducts = () => {
    sessionStorage.setItem("CategoryID", category.ProductCategoryID);
    sessionStorage.setItem("CategoryName", category.CategoryName); // Store Category Name
    navigate(`/AdminProduct`);
  };

  const handleChangeDisplayImage = () => {
    sessionStorage.setItem("CategoryID", category.ProductCategoryID);
    sessionStorage.setItem("CategoryName", category.CategoryName); // Store Category Name
    navigate(`/AdminProductChangeImg`);
  };

  return (
    <Card
      hoverable
      style={{
        width: "100%",
        border:
          category.Status === "Available" ? "1px solid #52c41a" : undefined,
      }}
    >
      <Row align="middle" gutter={[16, 16]}>
        {/* Image on the left */}
        <Col xs={6} sm={4} md={4}>
          <img
            alt={category.CategoryName}
            src={category.CategoryImage}
            style={{
              width: "100px",
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
        </Col>

        {/* Category details on the right */}
        <Col xs={12} sm={14} md={14}>
          <h4 style={{ margin: 0 }}>{category.CategoryName}</h4>
          <Tag color={statusColors[category.Status]}>{category.Status}</Tag>
        </Col>

        {/* Buttons */}
        <Col xs={6} sm={6} md={6} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            style={{ marginBottom: "8px", width: "100%" }}
            onClick={handleReOrderProducts}
          >
            Re Order Products
          </Button>
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={handleChangeDisplayImage}
          >
            Change Display Image
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default CategoryAdminCard;
